type ParamLocations = { Path?: string[]; Query?: string[]; Header?: string[]; Cookie?: string[] };

export const paramsToSelectItems = (params: ParamLocations | null | undefined): { Id: string; Name: string }[] => {
  if (!params) return [];
  const result: { Id: string; Name: string }[] = [];
  params.Path?.forEach((p) => result.push({ Id: `Path:${p}`, Name: `Path:${p}` }));
  params.Query?.forEach((p) => result.push({ Id: `Query:${p}`, Name: `Query:${p}` }));
  params.Header?.forEach((p) => result.push({ Id: `Header:${p}`, Name: `Header:${p}` }));
  params.Cookie?.forEach((p) => result.push({ Id: `Cookie:${p}`, Name: `Cookie:${p}` }));
  return result;
};

export const flattenParams = (params: ParamLocations | null | undefined): string[] => {
  if (!params) return [];
  const result: string[] = [];
  params.Path?.forEach((p) => result.push(`Path:${p}`));
  params.Query?.forEach((p) => result.push(`Query:${p}`));
  params.Header?.forEach((p) => result.push(`Header:${p}`));
  params.Cookie?.forEach((p) => result.push(`Cookie:${p}`));
  return result;
};

export const unflattenParams = (flat: string[]): ParamLocations => {
  const result: ParamLocations = {};
  for (const item of flat) {
    const colonIndex = item.indexOf(':');
    if (colonIndex === -1) continue;
    const key = item.substring(0, colonIndex) as keyof ParamLocations;
    const name = item.substring(colonIndex + 1);
    if (!result[key]) result[key] = [];
    result[key]!.push(name);
  }
  return result;
};

export const ENUM_LABEL_OVERRIDES: Record<string, Record<string, string>> = {
  RateLimitTimeframe: {
    PerSecond: '1 second',
    PerTenSeconds: '10 seconds',
    PerOneMinute: '1 minute',
    PerFiveMinutes: '5 minutes',
    PerFifteenMinutes: '15 minutes',
    PerOneHour: '1 hour',
  },
};

export const UPGRADE_MODAL_DATA = {
  title: 'Keep the good API traffic.<br />Block the bad actors.',
  extra: {
    title: 'Unlock API Guardian for Proactive API Protection',
    description: `Your current plan doesn't validate API requests or authentication. That means malformed payloads and unauthorized calls can slip through, break your logic, and expose your endpoints without you ever noticing.<br /><br />Bunny Shield Advanced with API Guardian gives you full visibility and control over API traffic, so every request matches your schema and every caller proves who they are.`,
    itemsList: [
      { icon: 'circle-check', text: 'Schema validation to block malformed or unexpected API requests', iconContextType: 'dark' },
      { icon: 'circle-check', text: 'Authentication validation to stop unauthorized access and token abuse', iconContextType: 'dark' },
      { icon: 'circle-check', text: 'Full visibility into API traffic, errors, and suspicious patterns hitting your endpoints', iconContextType: 'dark' },
    ],
  },
};

export type ApiGuardianEnumsMap = { [key: string]: { [key: string]: string } };

export const enumToSelectItems = (enums: ApiGuardianEnumsMap | undefined, enumName: string, useNameAsId = false): { Id: number | string; Name: string }[] => {
  const enumMap = enums?.[enumName];
  if (!enumMap) return [];
  const overrides = ENUM_LABEL_OVERRIDES[enumName];
  return Object.entries(enumMap).map(([value, name]) => ({
    Id: useNameAsId ? name : Number(value),
    Name: overrides?.[name] ?? name,
  }));
};
